<template>
    <HomeEventsPage />
</template>

<script lang="ts" setup>
    import HomeEventsPage from '~/components/HomeEventsPage.vue';
</script>
